export const localStorageKeys = {
  likeProduct: "likeProduct",
  cartProduct: "cartProduct",
} as const;

export interface StorageModel {
  id: number;
  isLike: boolean;
  quantity: number;
}

const saveArrayToLocalStorage = (key: string, array: any[]) => {
  localStorage.setItem(key, JSON.stringify(array));
};

export const loadArrayFromLocalStorage = (key: string): StorageModel[] => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : [];
};

export const addItemToLocalStorageArray = (key: string, item: StorageModel) => {
  const existingArray = loadArrayFromLocalStorage(key);
  const updatedArray = [...existingArray, item];
  saveArrayToLocalStorage(key, updatedArray);
};

export const removeItemFromLocalStorageArray = (key: string, id: number) => {
  const existingArray = loadArrayFromLocalStorage(key);
  const updatedArray = existingArray.filter((item) => item.id !== id);
  saveArrayToLocalStorage(key, updatedArray);
};
